import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

// Real backend: POST /:id/disposal — assetId in the URL, body: { disposalDate, disposalMethod, disposalReason, disposalValue, approvedBy, notes, attachments }
export const disposeAsset = createAsyncThunk("disposeAsset", async ({ assetId, data, form }) => {
	const response = await axiosHttp.post(`assets/${assetId}/disposal`, data);
	form.resetFields();
	message.success("Asset disposed!");
	return response.data?.data ?? response.data;
});

const DisposalCreateSlice = createSlice({
	name: "disposalCreateSlice",
	initialState: { isLoading: false, error: null, data: null },
	extraReducers: (builder) => {
		builder.addCase(disposeAsset.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(disposeAsset.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(disposeAsset.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default DisposalCreateSlice.reducer;